import { Link } from "react-router-dom";
import { useAvailability } from "../hooks/useAvailability";
import { buildings as staticBuildings } from "../data/buildings";
import StudioCard from "../components/common/StudioCard";
import EnquiryForm from "../components/common/EnquiryForm";

export default function Availability() {
  const { getBuildingWithStudios, loading, error } = useAvailability();
  const buildingsWithStudios = getBuildingWithStudios();

  function getStaticBuilding(slug) {
    return staticBuildings.find((b) => b.slug === slug);
  }

  return (
    <main className="pt-16 md:pt-20">
      <section
        className="relative w-full h-64 md:h-80 flex items-center justify-center"
        style={{ backgroundImage: "url('/static/images/hero-availability.webp')", backgroundSize: "cover", backgroundPosition: "center" }}
      >
        <div className="absolute inset-0 bg-black/50" />
      </section>

      <section className="w-full px-4 sm:px-8 lg:px-16 py-12 bg-[#f5f4f0]">
        <h1 className="text-3xl md:text-4xl font-semibold text-gray-900 mb-4">Current Availability</h1>
        <p className="text-gray-600 leading-relaxed max-w-2xl text-base">
          Discover the available studio spaces across all of our properties. Whether you're seeking a cozy creative workspace or a larger studio for your team, we have a variety of options to suit your needs. Explore our current listings and find the perfect place to bring your ideas to life.
        </p>
      </section>

      <section className="w-full px-4 sm:px-8 lg:px-16 py-12 bg-[#f5f4f0]">
        {loading && <p className="text-gray-500 text-base py-8">Loading availability...</p>}
        {error && (
          <p className="text-red-500 text-base py-8">
            Unable to load availability right now. Please <Link to="/contact" className="underline">contact us</Link> directly.
          </p>
        )}
        {!loading && !error && buildingsWithStudios.length === 0 && (
          <p className="text-gray-500 text-base py-8">No studios currently available. Please check back soon.</p>
        )}
        {!loading && !error && buildingsWithStudios.map((building) => {
          const staticData = getStaticBuilding(building.slug);
          const area = staticData?.area || "";
          const name = staticData?.name || building.name;

          return (
            <div key={building.slug} className="mb-16">
              <Link to={`/our-locations/${building.slug}`} className="group inline-flex items-center gap-2 mb-8">
                <h2 className="text-2xl md:text-3xl font-semibold text-gray-900">
                  {area && <span className="font-bold">{area} - </span>}
                  <span className="font-light">{name}</span>
                </h2>
                <span className="text-gray-400 group-hover:translate-x-1 transition-transform duration-200">→</span>
              </Link>
              <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                {building.studios.map((studio) => (
                  <StudioCard key={studio.id} studio={studio} />
                ))}
              </div>
              <div className="mt-12 border-t border-gray-300" />
            </div>
          );
        })}
      </section>

      <EnquiryForm pageUri="https://artistic-spaces.co.uk/availability" pageName="Current Availability" />
    </main>
  );
}